__webpack_require__.p = "/src/skins/passion-for-pets/";